import React from "react";
import TecoShopsContextProvider from "./src/context/TecoShopContextProvider";
import { ConfigProvider } from 'antd';
import type { GatsbyBrowser } from "gatsby"
import './src/styles/global.css';
import { HelmetProvider } from "react-helmet-async";

const helmetContext = {};

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => (

    <HelmetProvider context={helmetContext}>
        <TecoShopsContextProvider>
            <ConfigProvider>
                {element}
            </ConfigProvider>
        </TecoShopsContextProvider>
    </HelmetProvider>

)